let catalogUidSeed = 0

function nextCatalogUid(prefix = 'cat') {
  catalogUidSeed += 1
  return `${prefix}-${Date.now()}-${catalogUidSeed}`
}

function normalizeLessonName(lesson) {
  if (lesson == null) return ''
  if (typeof lesson === 'string') return lesson
  if (typeof lesson === 'object') {
    return String(lesson.name || lesson.title || '').trim()
  }
  return String(lesson).trim()
}

export function createEmptyCatalogChapter() {
  return { _uid: nextCatalogUid('chapter'), title: '', lessons: [] }
}

export function createEmptyCatalogLesson() {
  return ''
}

export function parseMaterialCatalogJson(json) {
  if (!json) return []
  try {
    const list = typeof json === 'string' ? JSON.parse(json) : json
    if (!Array.isArray(list)) return parsePlainCatalogLines(json)
    if (list.length && Array.isArray(list[0]?.lessons)) {
      return list.map(item => ({
        _uid: item._uid || nextCatalogUid('chapter'),
        title: item.title || '',
        lessons: (item.lessons || []).map(normalizeLessonName).filter(Boolean)
      }))
    }
    return parsePlainCatalogLines(json)
  } catch (e) {
    return parsePlainCatalogLines(json)
  }
}

function parsePlainCatalogLines(raw) {
  const text = typeof raw === 'string' ? raw : ''
  if (!text.trim()) return []
  const lines = text.split(/\r?\n/).map(s => s.trim()).filter(Boolean)
  return lines.length ? [{ _uid: nextCatalogUid('chapter'), title: '目录', lessons: lines }] : []
}

export function serializeMaterialCatalog(chapters) {
  const list = (chapters || [])
    .map(ch => ({
      title: (ch.title || '').trim(),
      lessons: (ch.lessons || []).map(normalizeLessonName).filter(Boolean)
    }))
    .filter(ch => ch.title || ch.lessons.length)
  return JSON.stringify(list)
}

export function defaultMaterialForm(extra = {}) {
  return {
    learningGoals: '',
    targetAudience: '',
    catalogChapters: [],
    materialFileUrl: '',
    ...extra
  }
}
